import React from 'react';
import { mergeClassNames } from '../../../utils';
import styles from './index.module.scss';

export default function Button({
  clickHandler,
  title = null,
  keyHandler = null,
  tabIndex = null,
  children = null,
  disabled = false,
  className = null,
  style = null,
  type = null,
  startIcon = null,
  endIcon = null,
  buttonStyle = false,
  linkStyle = false,
}) {
  if (startIcon && endIcon) throw new Error('A button cannot have two icons');

  return (
    <button
      disabled={disabled}
      tabIndex={tabIndex}
      onKeyDown={keyHandler}
      onClick={clickHandler}
      title={title}
      className={mergeClassNames([
        styles.button,
        buttonStyle ? styles.buttonStyle : null,
        linkStyle ? styles.linkStyle : null,
        startIcon || endIcon ? styles.icon : null,
        startIcon || endIcon ? styles[endIcon ? 'right' : 'left'] : null,
        className,
      ])}
      style={style}
      type={type}
    >
      {startIcon && <span className={styles.iconContainer}>{startIcon}</span>}
      {children ? <span className={styles.textContainer}>{children}</span> : null}
      {endIcon && <span className={styles.iconContainer}>{endIcon}</span>}
    </button>
  );
}

export const types = {
  button: 'button',
  submit: 'submit',
  reset: 'reset',
};

export * from './PrimaryButton';
export * from './SecondaryButton';
export * from './LinkStyleButton';
export * from './prefilled/BackButton';
export * from './prefilled/CloseButton';
export * from './prefilled/DecrementButton';
export * from './prefilled/DocumentLinkButton';
export * from './prefilled/IncrementButton';
export * from './prefilled/RemoveButton';
